import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { Container } from '@mui/material';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';
import type { ITheme } from '../../../theme';

const useStyles = makeStyles()((theme: ITheme) => ({
  section: {
    color: 'inherit',
    width: '100%',
    maxWidth: '100%',
    textAlign: 'left',
    paddingBottom: 30,
    paddingTop: 20,
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  overflow: {
    overflowX: 'hidden',
  },
  fullHeight: {
    height: '100vh',
  },
  withCenteredText: {
    textAlign: 'center',
  },
  defaultStyle: {
    paddingTop: 30,
    paddingBottom: 50,
  },
  container: {
    [theme.breakpoints.down('smallMobile')]: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    },
  },
}));

export interface SimpleSectionProps extends PropsWithChildren {
  id: string;
  centerTitle?: boolean;
  fullHeight?: boolean;
  disableOverflow?: boolean;
  disablePadding?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disableGutters?: boolean;
}

const SimpleSection: React.FC<SimpleSectionProps> = ({
  id,
  centerTitle,
  fullHeight = false,
  children,
  disableOverflow = false,
  disablePadding = false,
  maxWidth = 'md',
  disableGutters = true,
}) => {
  const { classes } = useStyles();
  return (
    <section
      id={id}
      className={classNames(
        classes.section,
        fullHeight && classes.fullHeight,
        !disableOverflow && classes.overflow,
      )}
    >
      <Container
        maxWidth={maxWidth}
        disableGutters={disableGutters}
        className={classNames(classes.container, {
          [classes.withCenteredText]: centerTitle,
          [classes.defaultStyle]: !disablePadding,
        })}
      >
        {children}
      </Container>
    </section>
  );
};

export default SimpleSection;
